import { Link, Outlet } from 'react-router-dom'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { AdminModeOnboardingTrigger } from '../Onboarding/AdminModeOnboarding/AdminModeOnboardingTrigger.js'

export function DesignMode() {
  return (
    <>
      <AdminModeOnboardingTrigger />
      <Outlet />
      <DesignModeBlockScreen />
    </>
  )
}

function DesignModeBlockScreen() {
  return (
    <div className="lg:hidden h-full w-full absolute left-0 top-0 bg-surface flex items-center justify-center z-50">
      <div className="flex flex-col gap-6 items-center justify-center max-w-md p-4">
        <SvgIcon
          name="monitor-03"
          className="size-16 bg-action-primary text-white p-3 rounded-md"
        />
        <div className="flex flex-col gap-2 items-center justify-center">
          <Text variant="headingMd" className="text-content">
            <T
              id="Generics.DesignMode.DesktopOnly"
              defaultMessage="Desktop Only Feature"
            />
          </Text>
          <Text variant="bodyMd" className="text-center">
            <T
              id="Generics.DesignMode.DesktopOnlyDescription"
              defaultMessage="Design mode is only available on desktop devices for the best customization experience. Please switch to a larger screen or access administration instead."
            />
          </Text>
        </div>
        <div className="flex flex-col gap-2 items-center justify-center">
          <Button
            as={Link}
            to={adminRoutes.people.members}
            variant="secondaryNeutral"
            size="lg"
            trailingIcon={<SvgIcon name="arrow-right" />}
          >
            <T
              id="Generics.DesignMode.GoToAdminMode"
              defaultMessage="Go to Admin Mode"
            />
          </Button>
          <Text variant="labelSm" className="text-content-subdued">
            <T
              id="Generics.DesignMode.RequiredScreenSize"
              defaultMessage="Required screen size: 1024px or larger"
            />
          </Text>
        </div>
      </div>
    </div>
  )
}

export function DesignModeBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.design.root}>
      <T id="Generics.Design" defaultMessage="Design" />
    </Link>
  )
}
